module.exports = __WEBPACK_EXTERNAL_MODULE__supabase_supabase_js_51b752d5__;